export default __webpack_public_path__ + "static/media/account.0d9b39e0.svg";